<ng-template #loadingGeneral>
  <mat-spinner class="center"></mat-spinner>
  <p class="center">Loading...</p>
</ng-template>

<ng-container *ngIf="!loading else loadingGeneral">

  <mat-card appearance="outlined" fxLayout="column">

    <mat-card-header class="mb-2_5">
      <h2 mat-card-title>{{boxAndTestbed?.box?.identifier}}</h2>
    </mat-card-header>

    <mat-card-content>


      <div fxLayout="row">

        <div [fxFlex]="showDocs ? 25 : ''" class="ph-2_5" fxLayout="column">
          <h2>
            Box info
          </h2>
          <div fxLayout="column" fxLayoutGap="3%">

            <div fxLayout="row">
              <strong fxFlex="50">Enabled:</strong> {{boxAndTestbed?.box?.enabled}}
            </div>

            <div fxLayout="row">
              <strong fxFlex="50">Hardware Version:</strong> {{boxAndTestbed?.box?.hardwareVersion}}
            </div>

            <div fxLayout="row">
              <strong fxFlex="50">Software Version:</strong> {{boxAndTestbed?.box?.softwareVersion}}
            </div>

            <div fxLayout="row">
              <strong fxFlex="50">Status:</strong> {{boxAndTestbed?.box?.status! | splitCamelCase}}
            </div>

          </div>

        </div>

        <mat-divider [vertical]="true"></mat-divider>


        <div [fxFlex]="showDocs ? 25 : ''" fxLayout="column" class="padding-left">

          <h2>
            Testbed info
          </h2>

          <div fxLayout="column" fxLayoutGap="3%">

            <div fxLayout="row">
              <strong fxFlex="25">Identifier:</strong> {{boxAndTestbed?.testbed?.identifier}}
            </div>

            <div fxLayout="row">
              <strong fxFlex="25">Location:</strong> {{boxAndTestbed?.testbed?.address}}
            </div>

            <div fxLayout="row">
              <strong fxFlex="25">Company:</strong> {{boxAndTestbed?.testbed?.company?.companyName}}
            </div>

          </div>


        </div>


        <ng-container *ngIf="showDocs">

          <mat-divider [vertical]="true"></mat-divider>

          <div class="padding-left" fxFlex fxLayout="column">

            <h2>
              Documentation
            </h2>
            <aw-list-testbed-files [testbed]="boxAndTestbed?.testbed!" fxFlex></aw-list-testbed-files>

          </div>
        </ng-container>
      </div>

      <mat-dialog-actions fxLayoutAlign="end" fxLayoutGap="3%">

        <button (click)="showDocs = !showDocs" mat-button>
          <span *ngIf="!showDocs && boxAndTestbed?.testbed?.storage">Show Docs</span>
          <span *ngIf="showDocs">Hide Docs</span>
        </button>
      </mat-dialog-actions>

    </mat-card-content>
  </mat-card>
</ng-container>